import { storeSet, authPageCheck} from "@/mixins/Auth.js"

function setViewResolver(component) {
    return require('../views/' + component).default;
}
const layout = {
    render(h) {
        return h('router-view')
    }
}

export default [
    {
        path: '/',
        component: setViewResolver('Home'),
        name : 'Home',
        meta : { name : 'Main',title: '홈',sideName: '홈',sideHidden : true,},
        redirect: '/member/list'
    },
    {
        path: '/auth',
        component: setViewResolver('auth/Login'),
        meta: {title: '로그인', sideHidden: true, noHeader: true,},
        name: 'Auth',

    },
    {
        path: '/member',
        component: setViewResolver('RouteView'),
        name: 'Member',
        meta: {title: '회원관리',sideName:'회원관리', authRequired: true,},
        children:[
            {
                path: 'list',
                component: setViewResolver('member/Member'),
                name: 'Member',
                meta: {name: 'Member',title: '회원리스트', sideName: '회원리스트', authRequired: true,},
            },
            {
                path: 'create',
                component: setViewResolver('member/MemberCreate'),
                name: 'MemberCreate',
                meta: {name: 'MemberCreate',title: '회원등록', sideName: '회원등록', authRequired: true, sideHidden:true},
            },
            {
                path: 'curator/approve',
                component: setViewResolver('member/CuratorApprove'),
                name: 'CuratorApprove',
                meta: {name: 'CuratorApprove',title: '큐레이터 승인대기', sideName: '큐레이터 승인대기', authRequired: true,},
            },
            {
                path: 'quit',
                component: setViewResolver('member/MemberQuit'),
                name: 'MemberQuit',
                meta: {name: 'MemberQuit',title: '탈퇴 회원', sideName: '탈퇴 회원', authRequired: true,},
            },
            {
                path: 'detail/:mb_no',
                component: setViewResolver('member/MemberDetail'),
                name: 'MemberDetail',
                meta: {name: 'MemberDetail',title: '회원상세', sideName: '회원상세', authRequired: true, sideHidden:true},
            },
            {
                path: 'mingle/:mb_no',
                component: setViewResolver('member/MemberMingle'),
                name: 'MemberMingle',
                meta: {name: 'MemberMingle',title: '회원 밍글사용내역', sideName: '회원 밍글사용내역', authRequired: true, sideHidden:true},
            },
            {
                path: 'portfolio/:mb_no',
                component: setViewResolver('member/MemberPortfolio'),
                name: 'MemberPortfolio',
                meta: {name: 'MemberPortfolio',title: '회원 포트폴리오', sideName: '회원 포트폴리오', authRequired: true, sideHidden:true},
            },
            {
                path: 'collection/:mb_no',
                component: setViewResolver('member/MemberCollection'),
                name: 'MemberCollection',
                meta: {name: 'MemberCollection',title: '회원 갤러리', sideName: '회원 갤러리', authRequired: true, sideHidden:true},
            },
            {
                path: 'item/:mb_no',
                component: setViewResolver('member/MemberItem'),
                name: 'MemberItem',
                meta: {name: 'MemberItem',title: '회원 아이템', sideName: '회원 아이템', authRequired: true, sideHidden:true},
            },
            {
                path: 'utility/:mb_no',
                component: setViewResolver('member/MemberUtility'),
                name: 'MemberUtility',
                meta: {name: 'MemberUtility',title: '회원 유틸리티', sideName: '회원 유틸리티', authRequired: true, sideHidden:true},
            },
            {
                path: 'competition/:mb_no',
                component: setViewResolver('member/MemberCompetition'),
                name: 'MemberCompetition',
                meta: {name: 'MemberCompetition',title: '회원 공모전', sideName: '회원 공모전', authRequired: true, sideHidden:true},
            },
            {
                path: 'curator/:mb_no',
                component: setViewResolver('member/MemberCuration'),
                name: 'MemberCuration',
                meta: {name: 'MemberCuration',title: '회원 큐레이션', sideName: '회원 큐레이션', authRequired: true, sideHidden:true},
            },
            {
                path: 'collect/:mb_no',
                component: setViewResolver('member/MemberCollect'),
                name: 'MemberCollect',
                meta: {name: 'MemberCollect',title: '회원 컬렉션', sideName: '회원 컬렉션', authRequired: true, sideHidden:true},
            },
            // {
            //     path: 'curator/approve/:mb_no',
            //     component: setViewResolver('member/CuratorDetail'),
            //     name: 'CuratorDetail',
            //     meta: {name: 'CuratorDetail',title: '큐레이터 상세', sideName: '큐레이터 상세', authRequired: true, sideHidden:true},
            // },
            {
                path: 'curator/approve/apply/:idx',
                component: setViewResolver('member/CuratorUpdate'),
                name: 'CuratorUpdate',
                meta: {name: 'CuratorUpdate',title: '큐레이터 신청정보', sideName: '큐레이터 신청정보', authRequired: true, sideHidden:true},
            },
        ]
    },
    {
        path: '/item',
        component: setViewResolver('RouteView'),
        name: 'Item',
        meta: {title: '아이템 관리',sideName:'아이템 관리',  authRequired: true,},
        children:[
            {
                path: 'list',
                component: setViewResolver('item/Item'),
                name: 'Item',
                meta: {name: 'Item',title: '아이템', sideName: '아이템',},
            },
            {
                path: 'auto',
                component: setViewResolver('item/ItemAutoCreate'),
                name: 'ItemAutoCreate',
                meta: {name: 'ItemAutoCreate',title: '자동민팅', sideName: '자동민팅',},
            },
            {
                path: 'list/:idx',
                component: setViewResolver('item/ItemDetail'),
                name: 'ItemDetail',
                meta: {name: 'ItemDetail',title: '아이템 상세정보', sideName: '아이템 상세정보', sideHidden:true},
            },
            {
                path: 'list/:idx/utility',
                component: setViewResolver('item/ItemDetailUtility'),
                name: 'ItemDetailUtility',
                meta: {name: 'ItemDetailUtility',title: '아이템 상세정보', sideName: '아이템 상세정보', sideHidden:true},
            },
            {
                path: 'delete',
                component: setViewResolver('item/ItemDelete'),
                name: 'ItemDelete',
                meta: {name: 'ItemDelete',title: '삭제 아이템', sideName: '삭제 아이템',},
            },

            {
                path: 'delete/:idx',
                component: setViewResolver('item/ItemDeleteDetail'),
                name: 'ItemDeleteDetail',
                meta: {name: 'ItemDeleteDetail',title: '삭제 아이템 상세', sideName: '삭제 아이템 상세', sideHidden:true},
            },
            {
                path: 'detection/request',
                component: setViewResolver('item/DetectionRequest'),
                name: 'DetectionRequest',
                meta: {name: 'DetectionRequest',title: '검출 의뢰', sideName: '검출 의뢰',},
            },
            {
                path: 'detection/request/:idx',
                component: setViewResolver('item/DetectionRequestDetail'),
                name: 'DetectionRequestDetail',
                meta: {name: 'DetectionRequestDetail',title: '검출 의뢰 상세', sideName: '검출 의뢰 상세', sideHidden:true},
            },
            {
                path: 'collection',
                component: setViewResolver('item/ItemCollection'),
                name: 'ItemCollection',
                meta: {name: 'ItemCollection',title: '컬렉션', sideName: '컬렉션',},
            },

            {
                path: 'collection/:idx',
                component: setViewResolver('item/ItemCollectionDetail'),
                name: 'ItemCollectionDetail',
                meta: {name: 'ItemCollectionDetail',title: '컬렉션 상세', sideName: '컬렉션 상세', sideHidden:true},
            },
            {
                path: 'collection/:idx/item',
                component: setViewResolver('item/ItemCollectionDetailItem'),
                name: 'ItemCollectionDetailItem',
                meta: {name: 'ItemCollectionDetailItem',title: '컬렉션 상세', sideName: '컬렉션 상세', sideHidden:true},
            },
            {
                path: 'collection/:idx/utility',
                component: setViewResolver('item/ItemCollectionDetailUtility'),
                name: 'ItemCollectionDetailUtility',
                meta: {name: 'ItemCollectionDetailUtility',title: '컬렉션 상세', sideName: '컬렉션 상세', sideHidden:true},
            },
            {
                path: 'utility',
                component: setViewResolver('utility/Utility'),
                name : 'Utility',
                meta : { name : 'Utility',title: '유틸리티',sideName: '유틸리티',authRequired: true,},
            },
            {
                path: 'utility/:idx',
                component: setViewResolver('utility/UtilityDetailPublish'),
                name: 'UtilityDetailPublish',
                meta: {name: 'UtilityDetailPublish',title: '유틸리티 발행정보', sideName: '유틸리티 발행정보', authRequired: true, storeRequired: true, storeConfig: {userInfo: true}, sideHidden:true},
            },
            {
                path: "utility/:idx/pubcurrent",
                component: () => import('../views/utility/UtilityDetailPubCurrent.vue'),
                name: "UtilityDetailPubCurrent",
                beforeEnter: storeSet,
                meta: {
                    name: "UtilityDetailPubCurrent", title: "유틸리티 발행정보", authRequired: true, storeRequired: true, storeConfig: {userInfo: true},
                    sideHidden: true,
                },
            },
            {
                path: "utility/:idx/manager",
                component: () => import('../views/utility/UtilityDetailManager.vue'),
                name: "UtilityDetailManager",
                beforeEnter: storeSet,
                meta: {
                    name: "UtilityDetailManager", title: "유틸리티 발행정보", authRequired: true, storeRequired: true, storeConfig: {userInfo: true},
                    sideHidden: true,
                },
            },
            {
                path: 'utility/:idx/detail/:uu_idx',
                component: setViewResolver('utility/UtilityDetail'),
                name: 'UtilityDetail',
                meta: {name: 'UtilityDetail',title: '유틸리티 고유정보', sideName: '유틸리티 고유정보', sideHidden:true},
            },
            {
                path: "utility/:idx/detail/:uu_idx/use",
                component: () => import('../views/utility/UtilityUse.vue'),
                name: "UtilityUse",
                beforeEnter: storeSet,
                meta: {
                    name: "UtilityUse", title: "유틸리티 사용현황", authRequired: true, storeRequired: false, storeConfig: {userInfo: true},
                    sideHidden: true,
                },
            },
            {
                path: "utility/:idx/detail/:uu_idx/transaction",
                component: () => import('../views/utility/UtilityTransaction.vue'),
                name: "UtilityTransaction",
                beforeEnter: storeSet,
                meta: {
                    name: "UtilityTransaction", title: "유틸리티 사용현황", authRequired: true, storeRequired: false, storeConfig: {userInfo: true},
                    sideHidden: true,
                },
            },
        ]
    },
    {
        path: '/competition',
        component: setViewResolver('RouteView'),
        name: 'Item',
        meta: {title: '공모전 관리',sideName:'공모전 관리', authRequired: true,},
        children:[
            {
                path: 'list',
                component: setViewResolver('competition/Competition'),
                name: 'Competition',
                meta: {name: 'Competition',title: '공모전', sideName: '공모전',},
            },
            {
                path: 'list/:idx',
                component: setViewResolver('competition/CompetitionDetail'),
                name: 'CompetitionDetail',
                meta: {name: 'CompetitionDetail',title: '공모전 상세', sideName: '공모전 상세', sideHidden:true},
            },
            {
                path: 'list/:idx/entry',
                component: setViewResolver('competition/CompetitionDetailEntry'),
                name: 'CompetitionDetailEntry',
                meta: {name: 'CompetitionDetailEntry',title: '공모전 상세', sideName: '공모전 상세', sideHidden:true},
            },
            {
                path: 'list/:idx/award',
                component: setViewResolver('competition/CompetitionDetailAward'),
                name: 'CompetitionDetailAward',
                meta: {name: 'CompetitionDetailAward',title: '공모전 상세', sideName: '공모전 상세', sideHidden:true},
            },
        ]
    },

    {
        path: '/service',
        component: setViewResolver('RouteView'),
        name: 'Service',
        meta: {title: '서비스 관리',sideName:'서비스 관리', authRequired: true,},
        children:[
            {
                path: 'payment',
                component: setViewResolver('payment/PaymentCharge'),
                name: 'PaymentCharge',
                meta: {name: 'PaymentCharge',title: '충전/출금관리', sideName: '충전/출금관리',},
            },
            {
                path: 'payment/withdraw',
                component: setViewResolver('payment/PaymentWithdraw'),
                name: 'PaymentWithdraw',
                meta: {name: 'PaymentWithdraw',title: '충전/출금관리', sideName: '충전/출금관리',sideHidden: true},
            },
            {
                path: 'payment/diposit',
                component: setViewResolver('payment/PaymentDeposit'),
                name: 'PaymentDeposit',
                meta: {name: 'PaymentDeposit',title: '충전/출금관리', sideName: '충전/출금관리',sideHidden: true},
            },
            {
                path: 'product',
                component: setViewResolver('item/ProductManagement'),
                name: 'ProductManagement',
                meta: {name: 'ProductManagement',title: '상품 관리', sideName: '상품 관리',},
            },
            {
                path: 'product/service',
                component: setViewResolver('item/ProductService'),
                name: 'ProductService',
                meta: {name: 'ProductManagement',title: '상품 관리', sideName: '상품 관리',sideHidden: true},
            },
            {
                path: 'mingle',
                component: setViewResolver('mingle/MingleHistory'),
                name: 'MingleHistory',
                meta: {name: 'MingleHistory',title: '밍글 내역', sideName: '밍글 내역'},
            },
        ]
    },
    {
        path: '/site',
        component: setViewResolver('RouteView'),
        name: 'Site',
        meta: {title: '사이트 관리',sideName:'사이트 관리', authRequired: true,},
        children:[
            {
                path: 'premium',
                component: setViewResolver('premium/Premium'),
                name: 'PremiumMarket',
                meta: {name: 'PremiumMarket',title: '프리미엄 마켓', sideName: '프리미엄 마켓',},
            },
            {
                path: 'banner',
                component: setViewResolver('banner/Banner'),
                name: 'Banner',
                meta: {name: 'Banner',title: '배너 관리', sideName: '배너 관리',},
            },
            {
                path: 'notice',
                component: setViewResolver('board/Notice'),
                name: 'Notice',
                meta: {name: 'Notice',title: '공지사항', sideName: '공지사항',},
            },
            {
                path: '/notice/create',
                component: setViewResolver('board/NoticeCreate'),
                name: 'NoticeCreate',
                meta: {name: 'NoticeCreate',title: '공지사항 등록', sideName: '공지사항 등록', sideHidden:true},
            },
            {
                path: '/notice/:idx',
                component: setViewResolver('board/NoticeDetail'),
                name: 'NoticeDetail',
                meta: {name: 'NoticeDetail',title: '공지사항 상세', sideName: '공지사항 상세', sideHidden:true},
            },
            {
                path: 'faq',
                component: setViewResolver('board/Faq'),
                name: 'Faq',
                meta: {name: 'Faq',title: 'FAQ', sideName: 'FAQ',},
            },
            {
                path: 'category',
                component: setViewResolver('board/FaqCategory'),
                name: 'FaqCategory',
                meta: {name: 'FaqCategory', title: 'FAQ 카테고리', sideName: 'FAQ 카테고리', sideHidden: true},
            },
            {
                path: '/faq/create',
                component: setViewResolver('board/FaqCreate'),
                name: 'FaqCreate',
                meta: {name: 'FaqCreate',title: 'FAQ 등록', sideName: 'FAQ 등록', sideHidden:true},
            },
            {
                path: '/faq/:idx',
                component: setViewResolver('board/FaqDetail'),
                name: 'FaqDetail',
                meta: {name: 'FaqDetail',title: 'FAQ 상세', sideName: 'FAQ 상세', sideHidden:true},
            },
            {
                path: 'qna',
                component: setViewResolver('board/Qna'),
                name: 'Qna',
                meta: {name: 'Qna',title: '1:1문의', sideName: '1:1문의',},
            },
            {
                path: '/qna/:idx',
                component: setViewResolver('board/QnaDetail'),
                name: 'QnaDetail',
                meta: {name: 'QnaDetail',title: '1:1문의 상세', sideName: '1:1문의 상세', sideHidden:true},
            },
            {
                path: '/site/qna/:idx',
                component: setViewResolver('board/QnaDetail'),
                name: 'QnaDetail',
                meta: {name: 'QnaDetail',title: '1:1문의 상세', sideName: '1:1문의 상세', sideHidden:true},
            },
            {
                path: 'terms',
                component: setViewResolver('terms/Terms'),
                name: 'Terms',
                meta: {name: 'Terms',title: '약관/규정', sideName: '약관/규정',},
            },
            {
                path: 'terms/create/:type',
                component: setViewResolver('terms/TermsCreate'),
                name: 'TermsCreate',
                meta: {name: 'TermsCreate',title: '약관/규정 등록', sideName: '약관/규정 등록', sideHidden:true},
            },
            // {
            //     path: 'terms/:type/:c_idx',
            //     component: setViewResolver('terms/TermsDetail'),
            //     name: 'TermsDetail',
            //     meta: {name: 'TermsDetail', sideName: '약관상세', title: '약관상세', sideHidden: true, authRequired: true},
            // },
            // {
            //     path: "terms/:type/:c_idx/update",
            //     component: setViewResolver("terms/TermsUpdate"),
            //     name: "TermsUpdate",
            //     beforeEnter: storeSet,
            //     meta: {name: 'TermsUpdate', sideName: '약관 수정', title: '약관 수정', sideHidden: true, authRequired: true},
            // },
           {
                path: 'terms/:type/:idx',
                component: setViewResolver('terms/TermsDetail'),
                name: 'TermsDetail',
                meta: {name: 'TermsDetail',title: '약관/규정 상세', sideName: '약관/규정 상세', sideHidden:true},
            },
        ]
    },
    /*{
        path: '/board',
        component: setViewResolver('RouteView'),
        name : 'Board',
        meta : { name : 'Board',sideName:'고객센터관리', title: '고객센터관리'},
        children:[
            {
                path: 'notice',
                component: setViewResolver('notice/Notice'),
                name: 'Notice',
                beforeEnter: storeSet,
                meta: {name: 'Notice',title: '공지사항', sideName: '공지사항',authRequired: true },
            },
            {
                path: 'notice/create',
                component: setViewResolver('notice/NoticeCreate'),
                name: 'NoticeCreate',
                beforeEnter: storeSet,
                meta: {name: 'NoticeCreate',title: '공지사항등록', sideName: '공지사항등록',sideHidden:true,authRequired: true },
            },
            {
                path: 'notice/:idx',
                component: setViewResolver('notice/NoticeUpdate'),
                name: 'NoticeUpdate',
                beforeEnter: storeSet,
                meta: {name: 'NoticeUpdate',title: '공지사항수정', sideName: '공지사항수정',sideHidden:true,authRequired: true },
            },
            {
                path: 'faq',
                component: setViewResolver('faq/Faq'),
                name: 'Faq',
                beforeEnter: storeSet,
                meta: {name: 'Faq',title: 'FAQ', sideName: 'FAQ',authRequired: true },
            },
            {
                path: 'faq/create',
                component: setViewResolver('faq/FaqCreate'),
                name: 'FaqCreate',
                beforeEnter: storeSet,
                meta: {name: 'FaqCreate',title: 'FAQ등록', sideName: 'FAQ등록',sideHidden:true, authRequired: true},
            },
            {
                path: 'faq/:idx',
                component: setViewResolver('faq/FaqUpdate'),
                name: 'FaqUpdate',
                beforeEnter: storeSet,
                meta: {name: 'FaqUpdate',title: 'FAQ수정', sideName: 'FAQ수정',sideHidden:true, authRequired: true},
            },
            {
                path: 'qna',
                component: setViewResolver('qna/Qna'),
                name: 'Qna',
                beforeEnter: storeSet,
                meta: {name: 'Qna',title: '1:1문의', sideName: '1:1문의',authRequired: true },
            },
            {
                path: 'qna/create/:idx',
                component: setViewResolver('qna/QnaCreate'),
                name: 'QnaCreate',
                beforeEnter: storeSet,
                meta: {name: 'QnaCreate',title: '1:1문의 상세정보' , sideName: '1:1문의 상세정보',sideHidden:true, authRequired: true},
            },
            {
                path: 'qna/:idx',
                component: setViewResolver('qna/QnaDetail'),
                name: 'QnaDetail',
                beforeEnter: storeSet,
                meta: {name: 'QnaDetail',title: '1:1문의 상세정보' , sideName: '1:1문의 상세정보',sideHidden:true, authRequired: true},
            },
        ]
    },*/
]
